import React, { FC } from 'react';
import { ProductDropdown } from './product-dropdown';

export const ProductSearchForm: FC<{
  shipToId: string;
  plantId: string;
  salesOrg: string;
}> = ({ shipToId, plantId, salesOrg }) => {
  return (
    <ProductDropdown
      shipToId={shipToId}
      plantId={plantId}
      salesOrg={salesOrg}
    />
  );
};
